import React, { useState, useEffect, useMemo, useCallback } from "react";

// @mui material components
import Divider from "@mui/material/Divider";
import { v4 as uuidv4 } from "uuid";

// Soft UI Dashboard React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiInput from "components/SuiInput";

// Custom styles for the Modal
import ModalRoot from "containers/modal/ModalRoot";
import { Alert, Icon } from "@mui/material";
import { toast } from "react-toastify";
import Grid from "@mui/material/Grid";
import RecipeChart from "./recipeChart";
import Createable from "containers/Select";
import RichTextEditor from "components/RichTextEditor";
import { getWeeksArray } from "utils/common";
import CustomeDatepicker from "containers/Datepicker";

import { doc, getDoc } from "firebase/firestore";
import moment from "moment";
import { firestore } from "firebaseConfig";
import { TailSpin } from "react-loader-spinner";
import CustomButton from "containers/CustomButton";

import { getUserRecipes, AddDiet, EditDietChart } from "services/dietchart";
import { getClientDietChartForDate } from "services/dietchart";
import ModalHeader from "containers/modal-header";
import { useSelector, useDispatch } from "react-redux";
import {
  userSelector,
  getSavedDietChartTemplates,
} from "store/features/authSlice";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import DeselectIcon from "@mui/icons-material/Deselect";
import { AddRecipe } from "store/features/recipes";
import ApprovalToggle from "../../ChartTable/components/DietRow/ApprovalToggle";
import { getClientDetails } from "store/features/clientDetails";
import { clientDetailsSelector } from "store/features/clientDetails";
import { normalizeFoodCategory } from "utils/common";

function Modal({
  open,
  clients,
  handleCloseModal,
  id,
  selectedItem,
  setSelectedItem,
  setDietChart,
  client,
  setSelectedClientv1,
  editValue,
  mode,
  editHandler,
  viewHandler,
  approval,
  setApproval,
  approveCheckHandler,
  isSharedLink = false,
  clientTnCStatus,
  showApproval,
  isServiceActive,
  setClientActive,
}) {
  const { dietChartTemplates } = useSelector(userSelector);
  const { clientDetailsData } = useSelector(clientDetailsSelector);
  const [selectedTemplate, setSelectedTemplate] = useState({
    label: "",
    value: {},
  });

  const [dietChartTemplateNames, setDietChartTemplateNames] = useState([]);
  const [clientAllergicData, setClientAllergicData] = useState();

  useEffect(() => {
    if (clientDetailsData?.biochemical?.length) {
      const allergicSet = new Set();

      clientDetailsData.biochemical.forEach((entry) => {
        // Add from allergicFrom array
        if (Array.isArray(entry.allergicFrom)) {
          entry.allergicFrom.forEach((item) => {
            if (item && item.trim()) allergicSet.add(item.trim());
          });
        }

        // Add from allergicFoods string
        if (entry.allergicFoods && typeof entry.allergicFoods === "string") {
          const items = entry.allergicFoods
            .split(",")
            .map((item) => item.replace(/\n/g, "").trim())
            .filter(Boolean);

          items.forEach((item) => allergicSet.add(item));
        }
      });

      const formattedAllergies = Array.from(allergicSet).join(", ");
      setClientAllergicData(formattedAllergies);
    } else {
      setClientAllergicData("");
    }
  }, [clientDetailsData]);

  const dispatch = useDispatch();
  const [note, setNote] = useState("");

  // Sync T&C status from the pre-loaded client prop (edit/view mode)
  useEffect(() => {
    if (client?.isClientTermsAccepted !== undefined) {
      setIsClientTermsAccepted(client.isClientTermsAccepted);
    }
  }, [client, open]);

  useEffect(() => {
    dispatch(getSavedDietChartTemplates({ uid: id }));
    setClientAllergicData();
  }, [dispatch, id]);

  useEffect(() => {
    if (dietChartTemplates) {
      const templateNames = dietChartTemplates.map((template) => {
        return {
          label: template.templateName,
          value: {
            dietPlan: template.dietPlan,
            chartType: template.chartType,
            weekPlan: template.weekPlan,
            note: template.note,
          },
        };
      });
      setDietChartTemplateNames(templateNames);
    }
  }, [dietChartTemplates]);

  //default modal fields value
  const defaultHandler = useMemo(() => {
    return {
      clientName: null,
      toggleMode: "AND",
    };
  }, []);

  //error handler
  const errorDefault = useMemo(() => {
    return {
      clientName: null,
      date: null,
      notes: null,
      chartType: null,
      weekPlan: null,
    };
  }, []);

  const [formdata, setFormdata] = useState(defaultHandler);

  const [scrollToTop, setScrollToTop] = useState(0);
  const [isClientTermsAccepted, setIsClientTermsAccepted] = useState(0);

  const [errorMessage, setErrorMessage] = useState(errorDefault);
  const [loader, setLoader] = useState(false);

  //for recipes
  const [recipeLoader, setRecipeLoader] = useState(false);

  useEffect(() => {
    const gridEl = document.getElementById("grid");
    if (gridEl) {
      gridEl.scrollIntoView({ behavior: "smooth" });
    }
  }, [scrollToTop]);

  const getRecipesHandler = useCallback(async (id) => {
    try {
      setRecipeLoader(true);
      const data = await getUserRecipes(id);

      setRecipes(data);
      setRecipeLoader(false);
    } catch (err) {
      setRecipeLoader(false);
      toast.error("Something went wrong!!!");
    }
  }, []);
  const [recipes, setRecipes] = useState([]);
  useEffect(() => {
    if (open) {
      getRecipesHandler(id);
    } else {
      setRecipes([]);
    }
  }, [open, id, getRecipesHandler]);

  //default modal fields value
  const defaultHandlerv1 = useMemo(() => {
    return {
      id: null,
      andRecipe: null,
      alternativeName: null,
      name: null,
      description: null,
      preparation: null,
      calories: null,
      foodType: null,
      ingredients: null,
      groceryList: null,
      nutritions: null,
      howToTake: null,
      weight: null,
      foodCategory: null,
      qty: null,
      unit: null,
      time: null,
      image: null,
    };
  }, []);

  let dietChartObj = useMemo(() => {
    return {
      earlyMorning: [],
      breakfast: [],
      midMorning: [],
      brunch: [],
      midMeal: [],
      lunch: [],
      postLunch: [],
      evening: [],
      beforeDinner: [],
      dinner: [],
      postDinner: [],
      lateNight: [],
    };
  }, []);

  const [dietPlan, setDietPlan] = useState({ ...dietChartObj });
  const defaultErrorv1 = {
    name: false,
    description: true,
    preparation: false,
    calories: false,
    foodType: false,
    ingredients: false,
    nutritions: false,
    howToTake: false,
    weight: false,
    foodCategory: false,
    image: false,
    toggleMode: false,
  };

  const [chartError, setChartError] = useState({
    earlyMorning: [defaultErrorv1],
    breakfast: [defaultErrorv1],
    midMorning: [defaultErrorv1],
    brunch: [defaultErrorv1],
    midMeal: [defaultErrorv1],
    lunch: [defaultErrorv1],
    postLunch: [defaultErrorv1],
    evening: [defaultErrorv1],
    beforeDinner: [defaultErrorv1],
    dinner: [defaultErrorv1],
    postDinner: [defaultErrorv1],
    lateNight: [defaultErrorv1],
  });

  //for submitting data
  const submitHandler = async (e) => {
    if (!formdata.clientName) {
      toast.error("Please fill Client Name field");
      setErrorMessage({
        ...errorMessage,
        clientName: true,
      });
      return;
    }

    if (!dietPlan.from) {
      toast.error("Please fill Diet start date");
      setErrorMessage({
        ...errorMessage,
        from: true,
      });
      return;
    }
    if (!dietPlan.to) {
      toast.error("Please fill Diet end date");
      setErrorMessage({
        ...errorMessage,
        to: true,
      });
      return;
    }

    if (!dietPlan.weekPlan) {
      toast.error("Please fill Week Plan field");
      setErrorMessage({
        ...errorMessage,
        weekPlan: true,
      });
      return;
    }

    if (!dietPlan.chartType) {
      toast.error("Please fill Chart Type field");
      setErrorMessage({
        ...errorMessage,
        chartType: true,
      });
      return;
    }

    if (!dietPlan.notes) {
      toast.error("Please fill Notes for Client field");
      setErrorMessage({
        ...errorMessage,
        notes: true,
      });
      return;
    }

    if (dietPlan.from && dietPlan.to) {
      const startDate = new Date(dietPlan.from);
      const endDate = new Date(dietPlan.to);

      if (startDate > endDate) {
        toast.error("Please make sure End Date is after the Start Date.");
        setErrorMessage({
          ...errorMessage,
          from: true,
          to: true,
        });
        return;
      }
    }

    let keys = Object.keys(dietPlan);
    for (let i = 0; i < keys.length; i++) {
      if (
        dietPlan[keys[i]] &&
        keys[i] !== "from" &&
        keys[i] !== "to" &&
        keys[i] !== "notes" &&
        keys[i] !== "id" &&
        keys[i] !== "selected" &&
        keys[i] !== "date" &&
        keys[i] !== "clientName" &&
        keys[i] !== "dietChartId" &&
        keys[i] !== "clientId" &&
        keys[i] !== "createdAt" &&
        keys[i] !== "weekPlan" &&
        keys[i] !== "chartType"
      ) {
        let recipe = dietPlan[keys[i]];
        let recipeId = keys[i];
        const recipeIds = [
          "earlyMorning",
          "breakfast",
          "midMorning",
          "brunch",
          "midMeal",
          "lunch",
          "postLunch",
          "evening",
          "beforeDinner",
          "dinner",
          "postDinner",
          "lateNight",
        ];
        const recipeIds1 = [
          "Early Morning",
          "Breakfast",
          "Mid Morning",
          "Brunch",
          "Mid Meal",
          "Lunch",
          "Post Lunch",
          "Evening",
          "Before Dinner",
          "Dinner",
          "Post Dinner",
          "Late Night",
        ];
        for (let j = 0; j < recipe.length; j++) {
          if (
            recipe[j].name ||
            recipe[j].description ||
            recipe[j].preparation ||
            recipe[j].howToTake ||
            recipe[j].nutritions ||
            recipe[j].ingredients ||
            recipe[j].foodType ||
            recipe[j].calories ||
            recipe[j].weight ||
            recipe[j].foodCategory ||
            recipe[j].unit ||
            recipe[j].qty
          ) {
            if (!recipe[j].name && recipeId === recipeIds[i]) {
              toast.error(
                `Please enter a Recipe Name field for ${recipeIds1[i]}`
              );
              setChartError({
                ...chartError,
                [recipeId]: {
                  name: true,
                },
              });
              return;
            }

            if (!recipe[j].qty && recipeId === recipeIds[i]) {
              toast.error(`Please enter Qty. field for ${recipeIds1[i]}`);
              setChartError({
                ...errorMessage,
                [recipeId]: {
                  qty: true,
                },
              });
              return;
            }

            if (!recipe[j].unit && recipeId === recipeIds[i]) {
              toast.error(`Please fill Unit field for ${recipeIds1[i]}`);
              setChartError({
                ...errorMessage,
                [recipeId]: {
                  unit: true,
                },
              });
              return;
            }

            if (!recipe[j].foodCategory && recipeId === recipeIds[i]) {
              toast.error(
                `Please fill Food Category field for ${recipeIds1[i]}`
              );
              setChartError({
                ...errorMessage,
                [recipeId]: {
                  foodCategory: true,
                },
              });
              return;
            }

            if (!recipe[j].time && recipeId === recipeIds[i]) {
              toast.error(`Please fill Time field for ${recipeIds1[i]}`);
              setChartError({
                ...errorMessage,
                [recipeId]: {
                  time: true,
                },
              });
              return;
            }
          } else if (recipeId === recipeIds[i]) {
            toast.error(
              `Please fill all added recipe fields for ${recipeIds1[i]}`
            );
            setChartError({
              ...errorMessage,
              [recipeId]: {
                name: true,
                description: true,
                preparation: true,
                calories: true,
                foodType: true,
                ingredients: true,
                nutritions: true,
                howToTake: true,
                weight: true,
                foodCategory: true,
                // toggleType:true,
                toggleMode: true,
                image: true,
              },
            });
            return;
          }
        }
      }
    }

    try {
      setLoader(true);

      // Step 1: Normalize all recipe fields before saving
      function normalizeRecipeFields(recipe) {
        return recipe.map((item) => ({
          ...item,
          name: item.name?.value || item.name || "",
          unit: item.unit?.value || item.unit || "",
          foodCategory: normalizeFoodCategory(item.foodCategory),
          andRecipe: item.andRecipe?.value || item.andRecipe || "",
          alternativeName:
            item.alternativeName?.value || item.alternativeName || "",
        }));
      }

      const normalizedPlan = { ...dietPlan };
      delete normalizedPlan._initializedFor; // remove internal field
      const mealTypes = [
        "earlyMorning",
        "breakfast",
        "midMorning",
        "brunch",
        "midMeal",
        "lunch",
        "postLunch",
        "evening",
        "beforeDinner",
        "dinner",
        "postDinner",
        "lateNight",
      ];

      mealTypes.forEach((meal) => {
        if (Array.isArray(normalizedPlan[meal])) {
          normalizedPlan[meal] = normalizeRecipeFields(normalizedPlan[meal]);
        }
      });
      if (dietPlan?.dietChartId && mode === "edit") {
        const updatedDiet = await EditDietChart({
          formdata,
          dietPlan: normalizedPlan,
          uid: id,
        });

        setDietChart((prevDietCharts) =>
          prevDietCharts.map((item) =>
            item.dietChartId === updatedDiet.dietChartId ? updatedDiet : item
          )
        );
        toast.success("Diet updated successfully!!");
      } else {
        const commonChartId = uuidv4();

        const clientDietPlan = {
          ...normalizedPlan,
          date: new Date(dietPlan.from),
          createdAt: new Date(),
          clientName: formdata.clientName,
          clientId: formdata.clientId,
          dietChartId: commonChartId,
        };

        await AddDiet({
          formdata,
          dietPlan: clientDietPlan,
          uid: id,
        });

        setSelectedClientv1(formdata.clientName);
        toast.success("Diet added successfully!!");
      }

      setLoader(false);
      handleCloseModal();
      setTimeout(() => {
        setNote("");
        setSelectedDate(null);
        if (selectedItem) {
          setSelectedItem(null);
        }
        setFormdata({ ...defaultHandler });
        setDietPlan({ ...dietChartObj });
        setErrorMessage({ ...errorDefault });
      }, 500);
    } catch (e) {
      console.log({ e });
      setLoader(false);
      toast.error("Something went wrong, retry!!");
    }
  };

  const defaultTimeline = useMemo(
    () => [
      { title: "Early Morning", id: "earlyMorning" },
      { title: "Breakfast", id: "breakfast" },
      { title: "Mid Morning", id: "midMorning" },
      { title: "Brunch", id: "brunch" },
      { title: "Mid Meal", id: "midMeal" },
      { title: "Lunch", id: "lunch" },
      { title: "Post Lunch", id: "postLunch" },
      { title: "Evening", id: "evening" },
      { title: "Before Dinner", id: "beforeDinner" },
      { title: "Dinner", id: "dinner" },
      { title: "Post Dinner", id: "postDinner" },
      { title: "Late Night", id: "lateNight" },
    ],
    []
  );

  const timeline = useMemo(() => {
    const defaults = defaultTimeline;
    const defaultIds = new Set(defaults.map((item) => item.id));

    const additionalSchedules = Object.keys(dietPlan || {})
      .filter((key) => !defaultIds.has(key) && Array.isArray(dietPlan?.[key]))
      .map((key) => ({
        id: key,
        title: key
          .replace(/([A-Z])/g, " $1")
          .replace(/^./, (str) => str.toUpperCase()),
      }));

    return [...defaults, ...additionalSchedules];
  }, [defaultTimeline, dietPlan]);

  const [totalCalories, setTotalCalories] = useState(0);
  useEffect(() => {
    let planData = dietPlan?.chartCalories ?? dietPlan;
    let keys = Object.keys(planData);
    let calories = 0;

    for (let i = 0; i < keys.length; i++) {
      if (
        ![
          "from",
          "to",
          "notes",
          "id",
          "selected",
          "name",
          "clientName",
          "dietChartId",
          "createdAt",
          "weekPlan",
          "chartType",
          "clientId",
        ].includes(keys[i])
      ) {
        const meals = planData?.[keys[i]];
        if (Array.isArray(meals)) {
          calories += meals.reduce((acc, meal) => {
            acc +=
              meal.calories && !isNaN(meal.calories)
                ? parseFloat(meal.calories)
                : 0;
            return acc;
          }, 0);
        }
      }
    }
    setTotalCalories(calories);
  }, [dietPlan]);

  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    if (selectedItem !== null && open) {
      if (!selectedDate) {
        setFormdata((e) => {
          setClientActive?.(
            client
              ? {
                  clientName: {
                    label: client?.id
                      ? client?.name + ` (+91${client?.phoneNumber})`
                      : "",
                    value: client?.id,
                    name: client?.name,
                  },
                }
              : e.clientName
          );
          return {
            ...e,
            from: selectedItem?.from,
            to: selectedItem?.to,
            notes: selectedItem?.notes,
            clientName: client
              ? {
                  label: client?.id
                    ? client?.name + ` (+91${client?.phoneNumber})`
                    : "",
                  value: client?.id,
                  name: client?.name,
                }
              : e.clientName,
          };
        });
      }

      setDietPlan((prev) => {
        // if already initialized for this selected dietChartId, skip (prevents clobbering while typing)
        if (
          prev?._initializedFor &&
          prev._initializedFor === selectedItem?.dietChartId
        ) {
          return prev;
        }

        const newDiet = { ...prev };

        newDiet.clientId = selectedItem?.clientId;
        newDiet.date = selectedItem?.date;
        // scalar fields (do not overwrite meals/arrays unless explicitly present)
        newDiet.dietChartId = selectedItem?.dietChartId ?? prev.dietChartId;
        newDiet.weekPlan = selectedItem?.weekPlan
          ? { label: selectedItem.weekPlan, value: selectedItem.weekPlan }
          : prev.weekPlan;
        newDiet.chartType = selectedItem?.chartType
          ? { label: selectedItem.chartType, value: selectedItem.chartType }
          : prev.chartType;
        newDiet.from = prev.from ?? selectedItem?.from;
        newDiet.to = prev.to ?? selectedItem?.to;
        newDiet.notes = selectedItem?.notes ?? prev.notes;
        newDiet.createdAt = selectedItem?.createdAt ?? prev.createdAt;

        // Only import meal arrays from selectedItem if they exist — copy them to avoid shared refs
        Object.keys(selectedItem || {}).forEach((k) => {
          if (Array.isArray(selectedItem[k])) {
            newDiet[k] = selectedItem[k].map((it) => ({ ...it }));
          }
        });

        // mark as initialized for this selectedItem so we don't overwrite again
        newDiet._initializedFor = selectedItem?.dietChartId ?? null;

        return newDiet;
      });
    }
  }, [selectedItem, client, open, selectedDate]);

  const chartTypes = [
    { value: "Weekly", label: "Weekly", key: 1 },
    { value: "Plateau", label: "Plateau", key: 2 },
    { value: "Detox", label: "Detox", key: 3 },
  ];

  //recipe list
  const [recipeList, setRecipeList] = useState([]);
  useEffect(() => {
    const recipeArray = recipes.map((item, index) => {
      return {
        label: item.name,
        value: item.name,
        key: index,
        id: item?.id,
        name: item.name
          ? { label: item.name, value: item.name }
          : { label: "", value: "" },
        andRecipe: item.andRecipe
          ? { label: item.andRecipe, value: item.andRecipe }
          : { label: "", value: "" },
        alternativeName: item.alternativeName
          ? { label: item.alternativeName, value: item.alternativeName }
          : { label: "", value: "" },
        description: item?.description ?? "",
        preparation: item?.preparation ?? "",
        calories: item?.calories ?? "",
        foodType: item?.foodType ?? [],
        ingredients: item?.ingredients ?? [],
        groceryList: item?.groceryList ?? [],
        nutritions: item?.nutritions ?? [],
        howToTake: item?.howToTake ?? "",
        weight: item?.weight ?? "",
        foodCategory: item?.foodCategory
          ? typeof item.foodCategory === "object"
            ? item.foodCategory
            : { value: item.foodCategory, label: item.foodCategory }
          : { value: "", label: "" },
        qty: item?.qty ?? "",
        unit: item?.unit
          ? typeof item.unit === "object"
            ? item.unit
            : { value: item.unit, label: item.unit }
          : { value: "", label: "" },
        time: item?.time ?? "",
        toggleMode: item?.toggleMode ?? "AND",
        image: item?.image ?? null,
      };
    });
    setRecipeList(recipeArray);
  }, [recipes]);

  const [dietLoader, setDietLoader] = useState(false);

  async function getClientDietChart(date) {
    try {
      const dates = includeDates.filter((item) => {
        if (item.date) {
          const itemDate = moment(item.date);
          return itemDate.isSame(moment(date), "day");
        }
        const from = moment(item.from.toDate?.() || item.from);
        const to = moment(item.to.toDate?.() || item.to);
        return moment(date).isBetween(from, "day", "[]");
      });
      // let dates = includeDates.filter((item) => {
      //   const from = moment(item.from.toDate?.() || item.from);
      //   const to = moment(item.to.toDate?.() || item.to);
      //   return moment(date).isBetween(from, to, "day", "[]");
      // });

      if (dates.length === 0 || !dates[0]?.id) {
        toast.error("No diet plan found for the selected date.");
        setDietLoader(false);
        return;
      }
      setDietLoader(true);
      const docId = dates[0].id;
      const ref = doc(firestore, "dietplan", docId);
      const snapshot = await getDoc(ref);
      let data;
      let dietChartData = {};
      if (snapshot.exists()) {
        data = snapshot.data();

        let keys = Object.keys(data);
        for (let i = 0; i < keys.length; i++) {
          if (
            keys[i] !== "from" &&
            keys[i] !== "to" &&
            keys[i] !== "notes" &&
            keys[i] !== "clientId" &&
            keys[i] !== "clientName" &&
            keys[i] !== "createdAt" &&
            keys[i] !== "dietChartId" &&
            keys[i] !== "weekPlan" &&
            keys[i] !== "chartType"
          ) {
            if (Array.isArray(data[keys[i]])) {
              dietChartData[keys[i]] = [...data[keys[i]]];
            }
          }
        }
        dietChartData = {
          ...dietChartData,
          weekPlan: data?.weekPlan,
          chartType: data?.chartType,
          notes: data?.notes,
        };
        setSelectedItem(dietChartData);
        setDietLoader(false);
      } else {
        setDietLoader(false);
        toast.error("Client not found!!!");
      }
    } catch (err) {
      setDietLoader(false);
      toast.error("Server error!!!");
    }
  }

  //for cloning diet chart
  const [includeDates, setIncludeDates] = useState([]);
  const getIncludesDates = useCallback(async () => {
    try {
      setDietLoader(true);
      const id = formdata.clientName.value;
      const { data, note } = await getClientDietChartForDate(id);
      setIncludeDates(data);
      // Only pre-fill notes from the most recent chart when adding a new plan.
      // In edit/view mode the note belongs to the specific selectedItem already loaded.
      if (mode !== "edit" && mode !== "view") {
        setNote(note);
        setDietPlan((e) => ({ ...e, notes: note }));
      }
      setDietLoader(false);
    } catch (err) {
      setDietLoader(false);
    }
  }, [formdata?.clientName?.value, mode]);

  useEffect(() => {
    if (formdata?.clientName?.value) {
      getIncludesDates();
    }
  }, [getIncludesDates, formdata?.clientName?.value]);

  const onChangeDate = (date) => {
    setNote("");
    setSelectedTemplate({ label: "", value: {} });
    setDietPlan({ ...dietChartObj });
    setSelectedItem(null);
    if (date === null) return;
    if (!formdata.clientName) {
      toast.error("Please fill Client Name field first");
      return;
    }
    if (date) {
      setSelectedDate(date);
      getClientDietChart(date);
    } else {
      setSelectedItem({});
      setSelectedDate("");
    }
  };

  useEffect(() => {
    if (!editValue) {
      if (formdata?.clientName?.value) {
        setDietPlan({ ...dietChartObj });
        setSelectedItem(null);
        setSelectedTemplate({ label: "", value: {} });
        setSelectedDate(null);
        setIncludeDates(formdata.clientName?.dietDates ?? []);
      } else {
        setIncludeDates([]);
      }
    }
  }, [
    formdata?.clientName,
    editValue,
    formdata?.clientName?.dietDates,
    dietChartObj,
    setSelectedItem,
  ]);

  //for getting notes from previous day (add mode only)
  useEffect(() => {
    if (!editValue) {
      if (formdata?.clientName && formdata?.clientName?.note) {
        setNote(formdata.clientName.note);
        setDietPlan((e) => ({ ...e, notes: formdata.clientName.note }));
      } else {
        setNote("");
        setDietPlan((e) => ({ ...e, notes: "" }));
      }
    }
  }, [formdata?.clientName, editValue]);

  useEffect(() => {
    if (selectedItem?.notes) {
      setNote(selectedItem.notes);
    }
  }, [selectedItem]);

  return (
    <ModalRoot
      variant="permanent"
      ownerState={{ openConfigurator: open }}
      width="100%"
    >
      <SuiBox
        style={{ whiteSpace: "normal !important" }}
        display="flex"
        justifyContent="space-between"
        alignItems="baseline"
        pt={3}
        pb={0.8}
        px={3}
        id="grid"
      >
        <ModalHeader
          mode={mode}
          title="Diet Chart"
          subtitle={`You can view diet chart details below`}
        />

        <SuiBox ml={1} display="flex" alignItems="center">
          {showApproval && isSharedLink && approval !== null && (
            <ApprovalToggle
              item={{ ...selectedItem, isApproved: approval }}
              index={0}
              approveHandler={approveCheckHandler}
            />
          )}
          {formdata?.clientName ? (
            clientTnCStatus || isClientTermsAccepted ? (
              <CheckBoxIcon
                fontSize="medium"
                style={{ color: "green", marginRight: "8px" }}
              />
            ) : (
              <DeselectIcon
                fontSize="medium"
                style={{ color: "red", marginRight: "8px" }}
              />
            )
          ) : (
            ""
          )}

          <SuiTypography display="inline" variant="h6">
            {formdata?.clientName
              ? clientTnCStatus || isClientTermsAccepted
                ? "T & C Accepted"
                : "T & C Not Accepted"
              : ""}
          </SuiTypography>
        </SuiBox>

        <Grid item>
          {mode === "view" && (
            <Icon
              sx={({
                typography: { size, fontWeightBold },
                palette: { dark },
              }) => ({
                fontSize: `${size.md} !important`,
                fontWeight: `${fontWeightBold} !important`,
                stroke: dark.main,
                strokeWidth: "2px",
                cursor: "pointer",
                mt: 2,
                mr: 2,
              })}
              onClick={() => {
                editHandler(selectedItem);
              }}
            >
              edit
            </Icon>
          )}
          {mode === "edit" && (
            <Icon
              sx={({
                typography: { size, fontWeightBold },
                palette: { dark },
              }) => ({
                fontSize: `${size.md} !important`,
                fontWeight: `${fontWeightBold} !important`,
                stroke: dark.main,
                strokeWidth: "2px",
                cursor: "pointer",
                mt: 2,
                mr: 2,
              })}
              onClick={() => viewHandler(selectedItem)}
            >
              visibility
            </Icon>
          )}
          <Icon
            sx={({
              typography: { size, fontWeightBold },
              palette: { dark },
            }) => ({
              fontSize: `${size.md} !important`,
              fontWeight: `${fontWeightBold} !important`,
              stroke: dark.main,
              strokeWidth: "2px",
              cursor: "pointer",
              mt: 2,
            })}
            onClick={() => {
              handleCloseModal();
              setSelectedDate(null);
              setSelectedTemplate({ label: "", value: {} });
              setNote("");
              setDietPlan({ ...dietChartObj });
              setSelectedItem(null);
              setFormdata(defaultHandler);
              setClientAllergicData();
            }}
          >
            close
          </Icon>
        </Grid>
      </SuiBox>

      <Divider />
      {/* {clientAllergicData ? (
        <>
          <div id="warning-container" />
          <WarningBox
            title="This client is allergic to"
            message=""
            highlight={clientAllergicData}
            sticky={true}
          />
        </>
      ) : (
        ""
      )} */}
      <SuiBox pt={1.25} pb={3} px={3}>
        {formdata.clientName && !isServiceActive && !dietLoader && (
          <Alert
            severity="error"
            sx={{
              fontSize: "14px",
              fontWeight: 600,
              bgcolor: "#FDECEA",
              color: "#611A15",
              border: "2px solid #F44336",
              borderRadius: 2,
              boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
            }}
          >
            This client does not have any active service. Please activate a
            service before creating a diet chart.
          </Alert>
        )}

        <Grid container spacing={3} mb={4}>
          <Grid item xs={12} md={2}>
            <SuiBox lineHeight={1} mt={3}>
              <SuiTypography mb={1} variant="h6">
                Client Name*
              </SuiTypography>
              <Createable
                options={
                  open && editValue
                    ? [
                        {
                          label: client?.name + ` (+91${client?.phoneNumber})`,
                          value: client?.id,
                          name: client?.name,
                        },
                      ]
                    : clients ?? []
                }
                disabled={mode === "view"}
                error={errorMessage?.clientName}
                value={formdata?.clientName}
                style={{ borderRadius: "0.5rem", fontSize: 14 }}
                inputStyle={{
                  width: 190,
                  height: "1.800rem",
                  borderRadius: "0.5rem",
                }}
                placeholder="Choose client"
                onChange={(e) => {
                  setSelectedTemplate({ label: "", value: {} });
                  setNote("");
                  setFormdata({
                    ...formdata,
                    clientName: e,
                  });
                  setClientActive?.({
                    clientName: e,
                  });
                  setIsClientTermsAccepted(e.isClientTermsAccepted);
                  setErrorMessage({
                    ...errorMessage,
                    clientName: false,
                  });
                  dispatch(getClientDetails({ id: e.key }));
                }}
              />
            </SuiBox>
          </Grid>

          <Grid item xs={12} md={2}>
            <SuiBox lineHeight={1} mt={3}>
              <SuiTypography mb={1} variant="h6">
                Diet Start Date*
              </SuiTypography>
              <SuiInput
                disabled={mode === "view"}
                type="date"
                name="from"
                readOnly={mode === "view"}
                error={errorMessage?.from}
                value={dietPlan?.from ?? selectedItem?.from ?? ""}
                onChange={(e) => {
                  const newFromDate = e.target.value;
                  const toDate = dietPlan?.to;

                  if (newFromDate && toDate && newFromDate > toDate) {
                    setErrorMessage({
                      ...errorMessage,
                      from: true,
                      to: true,
                    });
                  } else {
                    setErrorMessage({
                      ...errorMessage,
                      from: false,
                      to: false,
                    });
                  }
                  setFormdata({
                    ...formdata,
                    [e.target.name]: e.target.value,
                  });
                  setDietPlan({
                    ...dietPlan,
                    [e.target.name]: e.target.value,
                  });
                }}
              />
            </SuiBox>
          </Grid>
          <Grid item xs={12} md={2}>
            <SuiBox lineHeight={1} mt={3}>
              <SuiTypography mb={1} variant="h6">
                Diet End Date*
              </SuiTypography>
              <SuiInput
                disabled={mode === "view"}
                type="date"
                name="to"
                readOnly={mode === "view"}
                error={errorMessage?.to}
                value={dietPlan?.to ?? selectedItem?.to ?? ""}
                onChange={(e) => {
                  const newToDate = e.target.value;
                  const fromDate = dietPlan?.from;

                  if (fromDate && newToDate && fromDate > newToDate) {
                    setErrorMessage({
                      ...errorMessage,
                      from: true,
                      to: true,
                    });
                  } else {
                    setErrorMessage({
                      ...errorMessage,
                      from: false,
                      to: false,
                    });
                  }

                  setDietPlan({
                    ...dietPlan,
                    [e.target.name]: e.target.value,
                  });
                  setFormdata({
                    ...formdata,
                    [e.target.name]: e.target.value,
                  });
                }}
              />
            </SuiBox>
          </Grid>
          <Grid item xs={12} md={2}>
            <SuiBox lineHeight={1} mt={3}>
              <SuiTypography mb={1} variant="h6">
                Week Plan*
              </SuiTypography>
              <Createable
                options={getWeeksArray() ?? []}
                disabled={mode === "view"}
                error={errorMessage?.weekPlan}
                value={dietPlan?.weekPlan ?? ""}
                style={{ borderRadius: "0.5rem", fontSize: 14 }}
                inputStyle={{
                  width: 190,
                  height: "1.800rem",
                  borderRadius: "0.5rem",
                }}
                placeholder="Week plan"
                onChange={(e) => {
                  setDietPlan({
                    ...dietPlan,
                    weekPlan: e,
                  });

                  setErrorMessage({
                    ...errorMessage,
                    weekPlan: false,
                  });
                }}
              />
            </SuiBox>
          </Grid>
          <Grid item xs={12} md={2}>
            <SuiBox lineHeight={1} mt={3}>
              <SuiTypography mb={1} variant="h6">
                Chart Type*
              </SuiTypography>
              <Createable
                options={chartTypes ?? []}
                disabled={mode === "view"}
                error={errorMessage?.chartType}
                value={dietPlan?.chartType ?? ""}
                style={{ borderRadius: "0.5rem", fontSize: 14 }}
                inputStyle={{
                  width: 190,
                  height: "1.800rem",
                  borderRadius: "0.5rem",
                }}
                placeholder="Chart type"
                onChange={(e) => {
                  setDietPlan({
                    ...dietPlan,
                    chartType: e,
                  });

                  setErrorMessage({
                    ...errorMessage,
                    chartType: false,
                  });
                }}
              />
            </SuiBox>
          </Grid>
          <Grid item xs={12} md={2}>
            <SuiBox lineHeight={1} mt={3}>
              <SuiTypography mb={1} variant="h6">
                Select Template
              </SuiTypography>
              <Createable
                isClearable
                options={dietChartTemplateNames}
                value={selectedTemplate}
                style={{ borderRadius: "0.5rem", fontSize: 14 }}
                inputStyle={{
                  width: 190,
                  height: "1.800rem",
                  borderRadius: "0.5rem",
                }}
                placeholder="Select Template"
                onChange={(e) => {
                  setSelectedDate(null);
                  setSelectedTemplate(e);
                  setSelectedItem((pre) => {
                    return {
                      ...pre,
                      ...e?.value?.dietPlan,
                      weekPlan: e?.value?.weekPlan?.value,
                      chartType: e?.value?.chartType?.value,
                      notes: e?.value?.note,
                    };
                  });
                  setDietPlan((pre) => ({
                    ...pre,
                    ...e?.value?.dietPlan,
                    weekPlan: e?.value?.weekPlan,
                    chartType: e?.value?.chartType,
                    notes: e?.value?.note,
                  }));
                  setNote(e?.value?.note);
                }}
              />
            </SuiBox>
          </Grid>

          {!editValue && mode !== "view" && (
            <Grid item xs={12} md={2}>
              <SuiBox lineHeight={1} mt={3}>
                <SuiTypography mb={1} variant="h6">
                  Clone From
                </SuiTypography>
                <CustomeDatepicker
                  selectedDate={selectedDate}
                  onChangeDate={onChangeDate}
                  includeDates={includeDates}
                  placeholder={"Clone diet chart"}
                />
              </SuiBox>
            </Grid>
          )}

          {dietLoader && (
            <Grid
              item
              mb={1}
              xs={12}
              md={1}
              style={{ display: "flex", alignItems: "flex-end" }}
            >
              <SuiBox>
                <TailSpin color="#17c1e8" height={30} width={30} />
              </SuiBox>
            </Grid>
          )}
        </Grid>

        <Grid container spacing={3}>
          {timeline.map((item, index) => (
            <Grid item xs={12} lg={12} key={index}>
              <RecipeChart
                recipeList={recipeList}
                readOnly={mode === "view"}
                defaultHandler={defaultHandlerv1}
                title={item.title}
                chartId={item.id}
                dietChart={dietPlan[item.id]}
                setDietPlan={setDietPlan}
                selectedItem={selectedItem}
                setSelectedItem={setSelectedItem}
                open={open}
                recipeLoader={recipeLoader}
                setScrollToTop={setScrollToTop}
              />
            </Grid>
          ))}

          <Grid item xs={12} lg={4}>
            <SuiBox
              p={2}
              style={{
                border: "1px solid #D2D6DA",
                boxShadow: "0px 4px 24px rgba(0, 0, 0, 0.05)",
                borderRadius: 8,
              }}
            >
              <SuiBox>
                <SuiTypography
                  style={{ textDecorationLine: "underline" }}
                  mb={1}
                  variant="h6"
                >
                  Notes/Guidelines*
                </SuiTypography>
              </SuiBox>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <SuiBox lineHeight={1} mt={3}>
                    <SuiTypography mb={1} variant="h6">
                      Some Notes for Client*
                    </SuiTypography>
                    <RichTextEditor
                      name="notes"
                      value={note}
                      onChange={({ target }) => {
                        const { name, value } = target;
                        setNote(value);
                        setErrorMessage((prev) => ({
                          ...prev,
                          [name]: false,
                        }));
                        setDietPlan((prev) => ({
                          ...prev,
                          [name]: value,
                        }));
                      }}
                      error={errorMessage?.notes}
                      readOnly={mode === "view"}
                      toolbar={true}
                      height={300}
                      borderRadius={"10px"}
                    />
                  </SuiBox>
                </Grid>

                {mode !== "view" && (
                  <Grid item xs={12} mx={7}>
                    <CustomButton
                      color="dark"
                      variant="gradient"
                      onClick={submitHandler}
                      fullWidth
                      width={180}
                      disabled={loader || !open || !isServiceActive}
                      style={{
                        marginBottom: 10,
                        height: 40,
                        width: 230,
                        padding: 10,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      title={
                        dietPlan?.dietChartId && mode === "edit"
                          ? "Edit Data"
                          : "Add Data"
                      }
                      loader={loader}
                    />
                  </Grid>
                )}
              </Grid>
            </SuiBox>

            <SuiBox
              p={2}
              style={{
                marginTop: 20,
                border: "1px solid #D2D6DA",
                boxShadow: "0px 4px 24px rgba(0, 0, 0, 0.05)",
                borderRadius: 8,
              }}
            >
              <SuiTypography variant="h6">
                Total calories: {totalCalories?.toFixed(2)}
              </SuiTypography>
            </SuiBox>
          </Grid>
        </Grid>
      </SuiBox>
    </ModalRoot>
  );
}

export default Modal;
